import React, { Component } from "react";
import { colors } from "../../theme/Colors";
import { Typography, Box } from "@mui/material";

export default class Timer extends Component {
  state = {
    minutes: 2,
    seconds: 0,
  };

  componentDidMount() {
    this.myInterval = setInterval(() => {
      const { seconds, minutes } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
        }
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  render() {
    const { minutes, seconds } = this.state;
    return (
      <div>
        {minutes === 0 && seconds === 0 ? (
          <></>
        ) : (
          <Box>
            <Box>
              <Typography variant="text_normal" mr>
                Vous devez attendre avant de pouvoir renvoyer le code de vérification.
              </Typography>
              <Typography variant="text_normal" color={colors.main}>
                {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
              </Typography>
            </Box>
          </Box>
        )}
      </div>
    );
  }
}
